import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Lock: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 292 432"
    width={292}
    height={432}
    fill="none"
    {...props}
  >
    <path
      fill="#80DFEA"
      fillRule="evenodd"
      d="M154.789 16.944c55.794.17 101.043 45.742 101.228 101.551v67.706h27.513a8.57 8.57 0 0 1 5.994 2.459 8.585 8.585 0 0 1 2.475 6.01v59.236a8.397 8.397 0 0 1-2.475 5.964 8.38 8.38 0 0 1-5.994 2.49h-27.513 25.391v152.457a16.84 16.84 0 0 1-4.949 11.927c-3.166 3.166-7.485 4.995-11.973 4.995H44.446c-4.488 0-8.791-1.813-11.973-4.995a16.885 16.885 0 0 1-4.964-11.927V262.36H52.9 25.403a8.41 8.41 0 0 1-5.98-2.49 8.397 8.397 0 0 1-2.474-5.964V194.67c0-2.244.892-4.396 2.475-6.01a8.507 8.507 0 0 1 5.979-2.459H52.9v-67.706c.184-55.81 45.434-101.382 101.228-101.55h.661Zm-.661 50.783h.323c28.02 0 50.783 26.821 50.783 50.783v67.706H103.683v-64.662c0-23.87 22.579-53.627 50.445-53.827Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBE6E1"
      fillRule="evenodd"
      d="M137.529 0c55.947 0 101.381 45.665 101.55 101.551v185.472h-50.783V101.551c0-23.901-22.747-50.783-50.783-50.783-28.019 0-50.783 26.867-50.783 50.783v185.472H35.947V101.551C36.162 45.649 81.597 0 137.53 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D2C8BE"
      fillRule="evenodd"
      d="M69.822 126.479c0-56.623 37.504-75.698 67.706-75.698-28.02 0-50.783 29.88-50.783 53.827v182.428H69.822V126.479ZM137.529 0c55.948 0 101.382 45.665 101.551 101.551v185.472h-16.923V101.551C222.157 47.816 181.242 0 137.529 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF612B"
      fillRule="evenodd"
      d="M264.478 245.455H10.58V397.89c0 4.5 1.788 8.799 4.957 11.975a16.924 16.924 0 0 0 11.973 4.971h220.038c4.492 0 8.803-1.794 11.973-4.971a16.947 16.947 0 0 0 4.957-11.975V245.455Z"
      clipRule="evenodd"
    />
    <path
      fill="#EB4600"
      fillRule="evenodd"
      d="M275.069 177.742a8.525 8.525 0 0 0-2.473-5.994 8.52 8.52 0 0 0-5.989-2.47H8.475a8.52 8.52 0 0 0-5.989 2.47 8.454 8.454 0 0 0-2.49 5.994v59.242c0 2.236.895 4.394 2.49 5.981a8.465 8.465 0 0 0 5.989 2.483h258.132a8.477 8.477 0 0 0 5.989-2.483 8.503 8.503 0 0 0 2.473-5.981v-59.242Z"
      clipRule="evenodd"
    />
    <path
      fill="#FAF8F2"
      d="M76.207 321.649c0-33.262 26.964-60.226 60.226-60.226 33.263 0 60.227 26.964 60.227 60.226 0 33.263-26.964 60.227-60.227 60.227-33.262 0-60.226-26.964-60.226-60.227Z"
    />
    <path
      fill="#FF612B"
      fillRule="evenodd"
      d="M174.991 295.716a4.51 4.51 0 0 0-6.383.002l-48.682 48.681 3.152 3.153a4.583 4.583 0 0 0 6.477.001l45.444-45.444a4.517 4.517 0 0 0 .001-6.385l-.009-.008Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF612B"
      fillRule="evenodd"
      d="M97.904 315.826a4.581 4.581 0 0 0 0 6.477l25.231 25.232a4.582 4.582 0 0 0 6.477-.001l3.31-3.31-28.47-28.47a4.579 4.579 0 0 0-6.477 0l-.071.072Z"
      clipRule="evenodd"
    />
  </Box>
)
export default Lock
